import React, { useState, useEffect } from "react";
import "./LPSlidingHeader.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const messages = [
  "Welcome to our site!",
  "Limited-time offers available!",
  "Check out our new products!",
  "Enjoy free shipping on orders over $50!",
  "Follow us on facebook!",
];

function LPSlidingHeader() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000); // Auto-slide every 5 seconds
    return () => clearInterval(interval);
  }, [index]);

  const nextSlide = () => {
    setIndex((prevIndex) => (prevIndex + 1) % messages.length);
  };

  const prevSlide = () => {
    setIndex(
      (prevIndex) => (prevIndex - 1 + messages.length) % messages.length
    );
  };

  return (
    <div className="lp-sliding-header">
      <button className="lp-arrow lp-left" onClick={prevSlide}>
        <FaChevronLeft />
      </button>
      <div className="lp-message">{messages[index]}</div>
      <button className="lp-arrow lp-right" onClick={nextSlide}>
        <FaChevronRight />
      </button>
    </div>
  );
}

export default LPSlidingHeader;
